import { useContext } from 'react';
import { ChatMessageContext } from '../context/DMProvider';

export const useMessages = () => {
  const context = useContext(ChatMessageContext);
  if (context === null) {
    throw new Error('User Direct Messages context must come from ChatMessageProvider');
  }
  return context;
};
